export default __webpack_public_path__ + "static/blackfriday-20a76a00e6e9cf251e7c983ab322fd68.png";